import type { VideoClient as ZoomVideoClient } from "@zoom/videosdk";
import { toZoomError } from "./error";
import { ZoomErrorCode } from "../types";

type VideoClient = typeof ZoomVideoClient;
type LeaveArgs = Parameters<VideoClient["leave"]>;

/**
 * Use this to leave a Zoom room instead of calling the Zoom SDK's leave method
 * directly as this will handle edge cases.
 */
export async function leaveRoom(
  videoClient: VideoClient,
  ...args: LeaveArgs
): Promise<void> {
  const shouldEndRoom = args[0];

  try {
    await videoClient.leave(...args);
  } catch (error) {
    const [zoomErrorCode, zoomError] = toZoomError(error);

    switch (zoomErrorCode) {
      case ZoomErrorCode.INSUFFICIENT_PRIVILEGES:
        if (shouldEndRoom) {
          // Leave without ending the room
          // See https://growtherapy.atlassian.net/browse/TREE-429
          await videoClient.leave(false);
        }
        return;
      default:
        throw zoomError;
    }
  }
}
